import "./chimney.css"
import Product1 from "./Product1"
import Alexa from "../images/alexa.jpg"
import chim1 from "../images/chim1.webp"
import chim2 from "../images/chim2.webp"
import chim3 from "../images/chim3.jpg"
import chim4 from "../images/chim4.webp"
import chim5 from "../images/chim5.webp"
import chim6 from "../images/chim6.webp"
import chim7 from "../images/chim7.webp"
import chim8 from "../images/chim8.webp"
import chimney1 from  "../images/chimney.jpg"


export default function chimney() {

  return (
    <div className="stdivinhome">
     <div className="add"><img src={chimney1} /></div>
      
      <div className="home">
      
        <div className="home__prd">

          <div className="home__prd1">

            <Product1 id="chimney1" prdName="Dell i5" img={chim1} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"  ></Product1>
            <Product1 id="chimney2" prdName="Dell i7" img={chim2} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>

          </div>

          <div className="home__prd1">

            <Product1 id="chimney3 " prdName="Hp i7" img={chim3} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>
            <Product1 id="chimney4" prdName="Hp i5" img={chim4} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>

          </div>

        </div>


        <div className="home__prd">

          <div className="home__prd1">

            <Product1 id="chimney5" prdName="Mack book " img={chim5} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"  ></Product1>
            <Product1 id="chimney6" prdName="Mackbook 2" img={chim6} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>

          </div>

          <div className="home__prd1">

            <Product1 id="chimney7" prdName="Mack book pro" img={chim7} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>
            <Product1 id="chimney8" prdName="Mack book pro" img={chim8} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>

          </div>

        </div>

      </div>

    </div>
  )
}